module.exports = __webpack_public_path__ + "img/contandoSegredo.72f4c075.png";